
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class InputFile extends Vue {
    model: any = [];
    @Prop({ default: 'Seleccionar archivo' }) label: string;
    @Prop({ default: '' }) allowedFormats: string;
    @Prop({ default: false }) multiple: boolean;

    @Emit()
    inputChanged(value) {
        return value;
    }

    @Emit()
    clearEvent() {}

    clearModel() {
        this.model = [];
    }

    mounted() {}
}
